import * as React from 'react';
import * as Modal from 'react-modal';

import { Close } from '../../../icons';
import { InfoBlockContainer } from '../../InfoBlock';
import { QuestionBlockContainer } from './QuestionBlock';
import * as styles from './styles/styles.css';

interface IFeedbackPopupProps {
  isOpen: boolean;
  onClose(): void;
}

export function FeedbackPopup({ isOpen, onClose }: IFeedbackPopupProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={{
        content: {
          background: 'white',
          border: '1px solid rgb(204, 204, 204)',
          borderRadius: 4,
          bottom: 40,
          left: 40,
          outline: 'none',
          overflow: 'visible',
          padding: 0,
          position: 'static',
          right: 40,
          top: 40,
          width: 500,
          zIndex: 101,
        },
        overlay: {
          alignItems: 'center',
          backgroundColor: 'rgba(24, 41, 48, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 100,
        },
      }}
    >
      <div className={styles['body']}>
        <div onClick={onClose} className={styles['close_icon']}>
          <Close />
        </div>
        <InfoBlockContainer />
        <QuestionBlockContainer />
      </div>
    </Modal>
  );
}
